import Consent from './../Consent.js'

$(function () {
    const moduleConsent = new Consent()
    moduleConsent.init()
})
